const selectorsForAutoPlayVideos = [
  '.header__background video',
  '.header-centered__background video',
];

/**
 * For WCAG 2.1 AA compliance the user must be able to stop any auto-playing media should they wish.
 * This script adds a clear play/pause button to the auto-playing hero banner videos in an unobtrusive way.
 */
export default function () {
  // Collect hero videos.
  const videos = selectorsForAutoPlayVideos
    .map((selector) => [...document.querySelectorAll(selector)])
    .flat();
  // Add a button ontop of any videos.
  videos.forEach((video, index) => {
    const button = document.createElement('button');
    const newVideoID = `heroVideo${index}`;
    video.id = newVideoID;
    button.innerHTML = `<span class="sr-only" role="" aria-controls="${newVideoID}">pause video</span>`;
    button.classList.add('autoplay-video-play-pause-button');
    button.classList.add('fas');
    // Attach play/pause functionality to button.
    button.addEventListener(
      'click',
      function (event) {
        // Toggle play/pause.
        if (video.paused) {
          // Play video.
          video.play();
          // Update button style.
          button.classList.remove('fa-play');
          button.classList.add('fa-pause');
          // Save satus of video to localstorage for use on subsequent navigations.
          localStorage.setItem('autoplay-hero-videos', 'play');
        } else {
          // Pause video.
          video.pause();
          // Update button style.
          button.classList.remove('fa-pause');
          button.classList.add('fa-play');
          // Save satus of video to localstorage for use on subsequent navigations.
          localStorage.setItem('autoplay-hero-videos', 'pause');
        }
      },
      true
    );
    // If videos were paused by the user on a previous page, pause them again.
    if (localStorage.getItem('autoplay-hero-videos') === 'pause') {
      // Update button style.
      button.classList.add('fa-play');
      // Pause video (timeout to push this action to the back of the JS stack).
      window.setTimeout(() => {
        video.pause();
      }, 100);
    } else {
      // Update button style.
      button.classList.add('fa-pause');
    }
    // Add button to page.
    video.parentElement.parentElement.appendChild(button);
  });
}
